<form [formGroup]="stepForm" *ngIf="stepForm">
  <div class="col-12">
    <h5 class="nmbcol">{{ "Sellers.Products.ExtraInfo" | translate }}</h5>
    <div class="cardbg-white">
      <div class="row">
        <div class="col-6 mb-3">
          <app-image
            [fieldObject]="controllers['image']"
            [fieldErrors]="formValidator.formErrors"
            [formControlRef]="convertControls(controllers['image'].fieldName)"
            [productType]="productTypeId"
            [isUpdate]="isUpdate"
          ></app-image>
        </div>
      </div>
    </div>
  </div>
  <div class="col-12">
    <div class="cardbg-white my-3">
      <div class="row">
        <div class="col-md-6 mb-3">
          <app-product-categories
            [defaultValue]="searchableSelectDefaultValue"
            [fieldObject]="controllers['category']"
            [fieldErrors]="formValidator.formErrors"
            [formControlRef]="
              convertControls(controllers['category'].fieldName)
            "
            [productType]="productTypeId"
            [productTypeName]= "productTypeName"
            [isUpdate]="isUpdate"
          ></app-product-categories>
        </div>
        <div class="col-md-6 mb-3">
          <app-datetime-range
            [fieldObject]="controllers['event_duration']"
            [mandatory]="true"
            [fieldErrors]="formValidator.formErrors"
            [formControlRef]="
              convertControls(controllers['event_duration'].fieldName)
            "
            [productType]="productTypeId"
            [isUpdate]="isUpdate"
          ></app-datetime-range>
        </div>
        <div class="col-md-6 mb-3">
          <app-text
            [fieldObject]="controllers['address']"
            [fieldErrors]="formValidator.formErrors"
            [formControlRef]="convertControls(controllers['address'].fieldName)"
            [productType]="productTypeId"
            [isUpdate]="isUpdate"
          ></app-text>
        </div>
        <div class="col-md-6 mb-3">
          <app-open-map
            [fieldObject]="controllers['event_location']"
            [fieldErrors]="formValidator.formErrors"
            [formControlRef]="
              convertControls(controllers['event_location'].fieldName)
            "
            [productType]="productTypeId"
            [isUpdate]="isUpdate"
          ></app-open-map>
        </div>
        <div class="col-12 mb-3">
          <app-text
            [fieldObject]="controllers['facebook']"
            [fieldErrors]="formValidator.formErrors"
            [formControlRef]="
              convertControls(controllers['facebook'].fieldName)
            "
            [productType]="productTypeId"
            [isUpdate]="isUpdate"
          ></app-text>
        </div>
        <div class="col-md-6 mb-3">
          <app-text-area
            [fieldObject]="controllers['Delivery_terms']"
            [fieldErrors]="formValidator.formErrors"
            [formControlRef]="
              convertControls(controllers['Delivery_terms'].fieldName)
            "
            [productType]="productTypeId"
            [isUpdate]="isUpdate"
          ></app-text-area>
        </div>
        <div class="col-md-6 mb-3">
          <app-text-area
            [fieldObject]="controllers['Return_terms']"
            [fieldErrors]="formValidator.formErrors"
            [formControlRef]="
              convertControls(controllers['Return_terms'].fieldName)
            "
            [productType]="productTypeId"
            [isUpdate]="isUpdate"
          ></app-text-area>
        </div>
      </div>
    </div>
  </div>
</form>
